module.exports = __webpack_public_path__ + "static/media/EverydayCreativity.4deb05e2.mp3";